import Styles from './ArticleLoadingPreview.module.scss'
import { Skeleton } from 'components/Skeleton/Skeleton'

export const ArticleLoadingPreview = () => {
  return (
    <div className={Styles.articleLoadingPreview}>
      <div className={Styles.title}>
        <Skeleton avatar={false} active paragraph={{ rows: 1 }} title={false} />
      </div>
      <div className={Styles.first}>
        <Skeleton avatar={false} active paragraph={{ rows: 5 }} title={false} />
      </div>
      <div className={Styles.second}>
        <Skeleton avatar={false} active paragraph={{ rows: 3 }} title={false} />
      </div>
      <div className={Styles.third}>
        <Skeleton avatar={false} active paragraph={{ rows: 4 }} title={false} />
      </div>
    </div>
  )
}
